var Accordion = function() {

	var comp = $('[data-component="accordion"]');

	this.init = function() {

		accordion();
	}

	function accordion() {
		$('.accordion-list').each(function () {
		    var $accordion = $(this);

		    $accordion.find('.accordion-header').on('click', function (e) {
		    	e.preventDefault();

		        $accordion.find('.accordion-body').slideUp();
		        $('.accordion-item').removeClass('active');

		        if (!$(this).next().is(':visible')) {
		        	$(this).parent().addClass('active');
		            $(this).next().slideDown();
	            }
		    });
		});
	}

	return this.init();

}
